/* eslint semi:0 */
import { nodes } from '../../jsCore/utils/dom'
import { connect } from 'react-redux'
import { randId } from '../../jsCore/utils/string'
import { findDOMNode } from 'react-dom'
import React, { Component } from 'react'
import reduxMount from '../../jsCore/utils/reduxMounter'
import * as montiplayerActions from '../monti/montiplayerActions'
import { withParentAttributesAsProps } from '../../jsCore/utils/reactUtils'
import { external as externalScriptLoader } from '../../jsCore/utils/script'
import { MOUNT_POINTS } from '../../jsCore/config/preRenderedSelectorsConfig'
import { Spinner } from '../../components/spinner/spinner'
import { externalScriptsConfig } from '../../jsCore/organizedByType/config/externalScripts'
import { newVideoLoaded } from '../../jsCore/store/recommendedVideos/recommendedVideos.actions'
import { getAnalyticsPageType } from '../../jsCore/utils/video'
import {
  montiReducer,
  isInitializedSelector,
  STATE_KEY,
  sdkLoadingStateSelector,
} from '../monti/montiReducer'

import publicPdo from '../../jsCore/application/pageDataObject'

function shouldSendMontiTagServerUrl() {
  return publicPdo.ads.property !== 'EI'
}

class MontiPlayerContainerComponent extends Component {
  constructor(props) {
    super(props)
    Object.assign(this, {
      id: `ID${randId()}`,
      initPlayer: this.initPlayer.bind(this),
    })
  }

  componentWillMount() {
    const { isInitialized, sdkLoadingState, loadSdk, sdkLoaded, options } = this.props
    this.dataset = options.dataset
    if (!isInitialized && !sdkLoadingState) {
      loadSdk()
      const src = externalScriptsConfig.monti.src(this.dataset.player_id)
      externalScriptLoader.load({
        config: {
          src,
          name: 'montiApiPlayer',
        },
      })(sdkLoaded)
    }
  }

  initPlayer(playerRef) {
    const { video_id: media_id } = this.dataset
    const montiConfig = this.montiSetupBaseConfig(playerRef, media_id)
    this.setupMontiPlayer(montiConfig).then(player => {
      this.onMontiSetup(player, media_id)
    })
  }

  montiSetupBaseConfig(playerRef, media_id) {
    return {
      config_name: `Editor Embedded player in ${publicPdo.getSiteDomainWithTld()}`,
      publisher_contribution: publicPdo.getSiteDomainWithTld(),
      player_id: this.dataset.player_id,
      media_id,
      player_pos: findDOMNode(playerRef),
      category_name: getAnalyticsPageType(),
      monetization: {
        strategy: 'before_video_play',
        ad_type: 'auto_dynamic_tag',
      },
      playback_method: 'without',
    }
  }

  setupMontiPlayer(montiConfig) {
    const monti = window.monti()
    if (shouldSendMontiTagServerUrl()) {
      return monti.setup(montiConfig)
    }
    return monti.setup({
      ...montiConfig,
      ...{
        monetization: {
          ad_type: 'jw_scheduler',
        },
      },
    })
  }

  onMontiSetup(player, media_id) {
    player.on('playlistItem', () => {
      newVideoLoaded(
        'jw',
        player.get('config').pid,
        player.get('config').playlistItem.mediaid || media_id
      )
    })
  }

  render() {
    const isPlayerInitalized = this.props.isInitialized
    return isPlayerInitalized
      ? <div id={this.id} ref={this.initPlayer} />
      : <Spinner isInitialized={isPlayerInitalized} contrastModifier={this.dataset.contrast} />
  }
}

const COMPONENT_NAME = 'montiplayerContainer'

function mapStateToProps(state) {
  return {
    isInitialized: isInitializedSelector(state),
    sdkLoadingState: sdkLoadingStateSelector(state),
  }
}

const montiContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: connect(mapStateToProps, montiplayerActions)(
    withParentAttributesAsProps(MontiPlayerContainerComponent)
  ),
  reducer: montiReducer,
}

function shouldMountMontiPlayer() {
  return nodes(MOUNT_POINTS.MONTI_BODY).length !== 0
}

export default function initMontiPlayers() {
  if (!shouldMountMontiPlayer()) {
    return false
  }
  return reduxMount({
    [MOUNT_POINTS.MONTI_BODY]: montiContainer,
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/monti/montiContainer.js